const NotFound = () => {
  return (
    <div className="flex flex-col font-bold text-center text-3xl text-blueSoft">
      <h2 className="mt-40 text-8xl">Error: 404</h2>
      <p className="py-5 text-5xl">Page Not Found</p>
    </div>
  );
};

export default NotFound;
